import { useEffect } from "react";

export const AdditionalScripts = () => {
  useEffect(() => {
    if (navigator.userAgent !== "ReactSnap") {
      //inject google ads script to head
      const adsByGoogleScript = document.createElement("script");
      adsByGoogleScript.src =
        "//pagead2.googlesyndication.com/pagead/js/adsbygoogle.js";
      adsByGoogleScript.async = true;

      document.head.appendChild(adsByGoogleScript);
    }
  }, []);

  return null;
};
